import httpClient from '@/shared/http-auth-client';

const login = (email, password) => httpClient.post('/login', { email, password });
const guestin = (email) => httpClient.post('/guest', { email });
const logout = (refreshToken) => httpClient.delete('/token', { data: { refreshToken } });
const refresh = (refreshToken) => httpClient.post('/token', { refreshToken });
const confirmRegisterEmail = (userName, rootURL) => httpClient.post('/confirm-email', { userName, rootURL });
const validRegistrationToken = (confirmToken) => httpClient.put('/valid-registration-token', { confirmToken });
const confirmUserEmail = (userName, rootURL, confirmType) => httpClient.post(
  '/confirm-email', { userName, rootURL, confirmType },
);
const validateTempToken = (tempToken) => httpClient.put('/valid-temp-token', { tempToken });
const validateSecurityCode = (securityCode) => httpClient.put('/valid-security-code', { securityCode });
const validateSecurityAnswer = (userId, securityQuestionId, answer) => httpClient.post(
  '/UsersSecurityQuestions/CheckSecurityQuestion', { userId, securityQuestionId, answer },
);
const fetchUserSecurityQuestions = (userId) => httpClient.get(
  `/UsersSecurityQuestions/${userId}?$expand=securityQuestion`, //
);
const getLoginUserMessage = (userName) => httpClient.get(`/Users/UserLoginMessage?userName=${userName}`);
const lockUser = (userName) => httpClient.put('/Users/Lock', { userName });
const updateUserEmail = (userId, newUserName, rootURL) => httpClient.post('/confirm-change-user-name', { userId, newUserName, rootURL });

export {
  login,
  guestin,
  logout,
  refresh,
  confirmRegisterEmail,
  validRegistrationToken,
  confirmUserEmail,
  validateTempToken,
  validateSecurityCode,
  validateSecurityAnswer,
  fetchUserSecurityQuestions,
  lockUser,
  updateUserEmail,
  getLoginUserMessage,
};
